import React, { Component } from 'react';
import {InputText} from 'primereact/inputtext';
import { connect } from 'react-redux';
import {Dropdown} from 'primereact/dropdown';
import {InputSwitch} from 'primereact/inputswitch';
import {Toast} from 'primereact/toast';
import {MultiSelect} from 'primereact/multiselect';
import Messages from '../../../shared/UI/Messages/Messages';
import axios from '../../../axios-url';


import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
import { DROPDOWN_CONFIG, WPSTATUS_MASTER_SUBMENU_ID} from '../../../shared/Config';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import * as actions from '../../../store/actions/index';

class AddWPStatusMaster extends Component {
    state = {
        roles : [],
        type: 'add',
        Id:null,
        UserId:null,
        EmployeeId: null,
        RoleId: null,
        functionalRoleId: [],
        functionalRoleOptions: [],
        UserId1: '',              
        FirstName : '',
        MiddleName : '',
        LastName : '',
        EmailId: '',
        Password : '',
        MobileNumber : '',
        Activedirectory : false,
        Adloginid : '',
        Disablelogin : false,
        IsActive : false,
        createdBy : (this.props.loggedUserDetail.userName) ?? 'Admin',
        createdDate : new Date(),
        CompanyId: this.props.loggedUserDetail.CompanyId,
        touch : false,
        //starts here
        employeeId: null,
        permStartSeq: '',
        permEndSeq: '',
        initialStatus: false,
        currentStatusCode: null,
        nxtAllwedStatCode: null,
        isSap: false,
        statusNum: '',
        applicableArea: '',
        statusText:'',
        statusDescription:'',
        statusId:'',
    }

    componentDidMount(){
        this.getAccess = HASACCESS(WPSTATUS_MASTER_SUBMENU_ID);
        let id = this.props.match.params.id;
        this.props.getMasterTableList('GetWPStatusList');  
        this.props.getMasterKeywordList('Employee');
        let type = this.props.match.params.type;
        this.setState({type});


        if(type !== 'add'){
            this.timer();
        }
    }

    timer = () =>{
        this.intervalID = setInterval(()=> {
            this.fetchSingleProcess();
        },2000)
    }    
    componentWillUnmount(){
        if(this.props.tableLists!==undefined) {
            clearInterval(this.intervalID);
        }
    }

    fetchSingleProcess = () =>{

        let id = this.props.match.params.id;   
        let type = this.props.match.params.type;
        let storageItems = [];
        if(this.props.tableLists!==undefined) {
            storageItems = this.props.tableLists;
            clearInterval(this.intervalID);
        }
        if(storageItems){
            let filterData = storageItems.find(el => el.statusId == id);
            if(filterData){
                let employeeList = this.props.GetEmployeedropdown;
                let employees = filterData.employeeNo.split(",");
                let empIds = employees.map(el => { return (employeeList.find( obj => obj.id == el).value)});

                let data = {
                    employeeId: empIds,
                    permStartSeq: filterData.nsonr, 
                    permEndSeq: filterData.hsonr,
                    initialStatus: filterData.inist,
                    currentStatusCode: filterData.stat,
                    nxtAllwedStatCode: filterData.nextallowedst.split(","),
                    isSap: filterData.sapstatus,
                    statusNum: filterData.stonr,
                    applicableArea: filterData.stsma,
                    statusText:filterData.txt04,
                    statusDescription:filterData.txt30,
                    statusId: filterData.statusId,
                }

                this.setState(data);
                
            }
        }

    }


    change = (e) => {
        let {name, value} = e.target;
        this.setState({[name]:value,touch:true})
    }

    add = () => {

        let employeeList = this.props.GetEmployeedropdown;
        let employees = this.state.employeeId;
        let empNos = employees.map(el => { return (employeeList.find( obj => obj.value == el).id)}).toString();
        

        let data = {
            StatusId: this.state.type == 'add' ? "00000000-0000-0000-0000-000000000000" : this.state.statusId , 
            Stsma : this.state.applicableArea,
            Stat : this.state.currentStatusCode,
            Inist : this.state.initialStatus,
            Stonr : this.state.statusNum,
            Nsonr : this.state.permStartSeq,
            Hsonr : this.state.permEndSeq,
            EmployeeNo : empNos,
            EmployeeId : '',
            Txt04 : this.state.statusText,
            Txt30 : this.state.statusDescription,
            Nextallowedst : this.state.nxtAllwedStatCode.toString(),
            Sapstatus : true,
        }
   
        
        if(this.state.type === 'add'){
        data.StatusId = "00000000-0000-0000-0000-000000000000";
        this.props.processDynamicData('WPStatus','add',data,'');
        } else if(this.state.type === 'edit'){
            this.props.processDynamicData('WPStatus','edit',data,'');
        }


    }

    resetData = () => {
        var data = {
            UserId: null,
            EmployeeId: null,            
            RoleId: null,
            UserId1:'',
            FirstName: '',
            MiddleName: '',
            LastName:'',
            EmailId: '',
            Password: '',
            MobileNumber: '',
            Activedirectory: false,
            Disablelogin: false,
            IsActive: false,
            type:'add'
        }
        this.setState(data);
    }
  
    render() {   
        if(this.props.success){
            REDIRECT_TO_URL('/WCAStatus/',this.props);
        }


        let addAccess = true;
        let editAccess = true;
        if(this.getAccess!==undefined){
            if(this.getAccess.viewAccess === false && this.props.userDetail.userId!==this.props.match.params.id){this.props.history.push('/dashboard')}
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess : addAccess, editAccess : editAccess}
        
        let roleOptions = [];
        if(this.props.Role && this.props.Role.length > 0 ){
            roleOptions = this.props.Role;
        }

        let isEnabled = (this.state.touch === true);

        let redirectURL = '/WCAStatus/';
        if(this.props.userDetail && this.props.match.params.id!==undefined){
            if(this.props.userDetail.userId === this.props.match.params.id){
                redirectURL = "/dashboard";
            }
        }

        let sapWorkPermitValues = [{label: "E0001 - Created", value:"E0001"},
        {label: "E0002 - Prepared", value:"E0002"},
        {label: "E0003 - Pending", value:"E0003"},
        {label: "E0004 - Clear", value:"E0004"},
        {label: "E0005 - Reissue", value:"E0005"},
        {label: "E0006 - Issued", value:"E0006"},
        {label: "E0007 - Accept", value:"E0007"},
        {label: "E0008 - Cancellation", value:"E0008"},
        {label: "E0009 - Surrender", value:"E0009"},
        {label: "E0016 - Surrender_Requested", value:"E0016"},
        {label: "E0015 - Re-Issue_Requested", value:"E0015"}] 
        

        return (
            <div className="p-grid">
                { this.props.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>{this.state.type} Status</h1>
     
                        <div className="p-grid mt1">

                            {/*
                            employeeId: null
                            employeeNo: "48,4,26,79,63,39,108" employee number *
                            hsonr: 9 permitted ending sequence *
                            inist: true intital status *
                            nextallowedst: "E0002" next allowed status *
                            nsonr: 1 permitted starting sequence *
                            sapstatus: true is sap status
                            stat: "E0001" status
                            statusId: "d8e9031e-435a-4189-8622-0818113f75b0"
                            stonr: 1 status number
                            stsma: "AZN-WZA" applicable area
                            txt04: "CRTD" 
                            txt30: "Created" description
                            
                            employeeId,
                            permStartSeq,
                            permEndSeq,
                            initialStatus,
                            currentStatusCode,
                            nxtAllwedStatCode,
                            isSap,
                            statusNum,
                            applicableArea,
                            statusText,
                            statusDescription
                            

                            
                            */}
                           
                            <div className="p-col-6 p-offset-3">
                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Employee(s) <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                <MultiSelect className="p-col-12" placeholder="Select Employee(s)" options={this.props.GetEmployeedropdown} value={this.state.employeeId} name="employeeId" onChange={this.change} {...DROPDOWN_CONFIG} />
                                </div>			


                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Permitted Starting Sequence <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                <InputText keyfilter="int" className="p-col-12" name="permStartSeq" placeholder="Permitted Starting Sequence" value={this.state.permStartSeq} onChange={this.change}/>
                                </div>	


                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Permitted Ending Sequence <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                <InputText keyfilter="int" className="p-col-12" name="permEndSeq" placeholder="Permitted Ending Sequence" value={this.state.permEndSeq} onChange={this.change}/>
                                </div>	

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Intial Status :</label>
                                </div>
                                <div className="p-col-12 ">
                                <InputSwitch checked={this.state.initialStatus} value={this.state.initialStatus} onChange={this.change} name="initialStatus" />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Current Status Code(s) <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                <Dropdown className="p-col-12" placeholder="Select Current Code(s)" options={sapWorkPermitValues} value={this.state.currentStatusCode} name="currentStatusCode" onChange={this.change} {...DROPDOWN_CONFIG} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Next Allowed Status Code(s) <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                <MultiSelect className="p-col-12" placeholder="Select Next Allowed Status Code(s)" options={sapWorkPermitValues} value={this.state.nxtAllwedStatCode} name="nxtAllwedStatCode" onChange={this.change} {...DROPDOWN_CONFIG} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Is SAP Status :</label>
                                </div>
                                <div className="p-col-12 ">
                                <InputSwitch checked={this.state.isSap} value={this.state.isSap} onChange={this.change} name="isSap" />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Status Number </label>
                                </div>
                                <div className="p-col-12 ">
                                <InputText keyfilter="int" className="p-col-12" name="statusNum" placeholder="Status Number" value={this.state.statusNum} onChange={this.change}/>
                                </div>	

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Applicable Area </label>
                                </div>
                                <div className="p-col-12 ">
                                <InputText className="p-col-12" name="applicableArea" placeholder="Applicable Area" value={this.state.applicableArea} onChange={this.change}/>
                                </div>	

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Status Text </label>
                                </div>
                                <div className="p-col-12 ">
                                <InputText className="p-col-12" name="statusText" placeholder="Status Text" value={this.state.statusText} onChange={this.change}/>
                                </div>	

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Status Description </label>
                                </div>
                                <div className="p-col-12 ">
                                <InputText className="p-col-12" name="statusDescription" placeholder="Status Description" value={this.state.statusDescription} onChange={this.change}/>
                                </div>	

                                
                            </div>
                            <div className="p-col-12 p-lg-12">

                                <FooterButton access={accessButton} disabled={false} type={this.state.type.toLowerCase()} save={this.add} reset={this.resetData}  to={redirectURL} />
                            
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        userDetail : state.auth.userDetail,
        userPref : state.auth.userPref,
        GetEmployeedropdown : (state.keyword.Employee!==undefined) ? state.keyword.Employee : [],
        loading : state.master.loading,
        error : state.master.error,
        success : state.master.success,
        Role : (state.keyword.Role!==undefined) ? state.keyword.Role : [],
        tableLists : state.master.tableLists
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
        fetchRelavantLists : (value) => dispatch(actions.fetchRelavantLists(value)),
        processDynamicData: (model,type,data,func) => dispatch(actions.processDynamicData(model,type,data,func)),
    }
}
  
export default connect(mapStateToProps,mapDispatchToProps)(AddWPStatusMaster);